import _ from 'lodash';
import { onCreatePayment, onCreateSubscription } from 'common/api/payment';
import { reactToastify, TOASTIFY_TYPES } from 'common/utils/reactToastify';
import { initiateUserAuth } from 'common/auth/modalLogin';
import { razorpayModal } from './razorpayModal';
import { cashfreeModal } from './cashfreeModal';
import { isCashfreePg, isAlgoversePg } from 'ui/QuotaVerification/helper';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import { QubitPaymentServices } from 'v3/pages/Plans/Qubit/QubitPaymentServices';

export const paymentInitialize = (args, immediateCallBackFunc = () => { }, isSubscription = false, setIsLoading) => {
  const isUserSignedIn = _.get(window, 'isUserSignedIn', false);
  const isEmailUser = _.get(window, 'isEmailUser', false);

  const onCreatePurchase = () => (isSubscription ? onCreateSubscription(args) : onCreatePayment(args));

  const processPurchase = () => {
    onCreatePurchase()
      .then((result) => {
        const { status, razorpay_order_id, price_total } = result;
        if (!status) {
          return reactToastify('Something went wrong, Please try again', TOASTIFY_TYPES.ERROR);
        }

        if (ApplicationDomainUtility.isQubit) {
          (async () => {
            try {
              await QubitPaymentServices.init({
                reference_id: razorpay_order_id,
                plan_name: args.plan_name,
                price: price_total
              });
            } catch (error) {
              console.log(error.message);
            }
          })();
          return;
        }

        if (result.razorpay_payment_link) {
          // for B2B Stockwiz purchase
          // If razorpay_payment_link is present, redirect to the payment link
          window.location.href = result.razorpay_payment_link;
          return null;
        }
        const razorpayOrderId = _.get(result, 'razorpay_order_id', '');
        const razorpaySubscriptionId = _.get(result, 'razorpay_subscription_id', '');
        const resyncTypes = _.get(result, 'resync_types', '');
        const gatewayExtras = _.get(result, 'gateway_extras', {});
        const { RAZORPAY_KEY_ID } = window;

        const razorpayModalArgs = {
          razorpayPurchaseId: razorpayOrderId || razorpaySubscriptionId,
          razorpayKeyId: RAZORPAY_KEY_ID,
          description: _.toString([resyncTypes]),
          isSubscription,
          resyncTypes,
          razorpayNotes: args,
          immediateCallBackFunc
        };

        const cashfreeModalArgs = {
          cashfreePurchaseId: razorpayOrderId || razorpaySubscriptionId,
          description: _.toString([resyncTypes]),
          isSubscription,
          resyncTypes,
          cashfreeNotes: args,
          gatewayExtras,
          immediateCallBackFunc
        };

        if (razorpayOrderId === 'credit_payment') {
          reactToastify('Hurray! Purchase completed', TOASTIFY_TYPES.SUCCESS);
          setTimeout(() => immediateCallBackFunc(), 2000);
          return null;
        }

        if (isCashfreePg) {
          return cashfreeModal(cashfreeModalArgs);
        }

        if (isAlgoversePg) {
          return immediateCallBackFunc(result);
        }

        return razorpayModal(razorpayModalArgs);
      })
      .catch(() => {
        reactToastify('Something went wrong, Please try again', TOASTIFY_TYPES.ERROR);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  if (!isUserSignedIn || isEmailUser) {
    initiateUserAuth({ action: 'plan_purchase', plan: args.addon_name })
      .then(() => processPurchase())
      .catch(() => {
        reactToastify('Unauthorized, Please login and Continue', TOASTIFY_TYPES.ERROR);
      }).finally(() => {
        setIsLoading(false);
      });
  } else {
    processPurchase();
  }
};
